import { ShopifyExtensionHandle } from 'corso-types';

export const extensionHandleLabel = {
  [ShopifyExtensionHandle.checkoutExtensionProduct]:
    'Checkout Extension - Product',
  [ShopifyExtensionHandle.checkoutExtensionShipping]:
    'Checkout Extension - Shipping',
  [ShopifyExtensionHandle.checkoutPlusScript]: 'Checkout Plus Script',
  [ShopifyExtensionHandle.checkoutPlusThemeAppEmbed]:
    'Checkout Plus Theme App Embed',
  [ShopifyExtensionHandle.customerAccount]: 'Customer Account',
  [ShopifyExtensionHandle.deliveryEstimate]: 'Delivery Estimate',
  [ShopifyExtensionHandle.deliveryGuarantee]: 'Delivery Guarantee',
  [ShopifyExtensionHandle.embeddedUi]: 'Embedded UI',
  [ShopifyExtensionHandle.orderEdit]: 'Order Edit',
  [ShopifyExtensionHandle.removeProduct]: 'Remove Product',
} satisfies Record<ShopifyExtensionHandle, string>;
